export default __webpack_public_path__ + "static/media/lock-closed.fa990ce3.svg";